import { Link } from 'react-router-dom';
import './experience-snapshot.css';

const EXPERIENCES = [
    {
        title: 'Lead Software Developer',
        company: 'Waffle Works Games',
        dates: 'Jun 2025 — Present',
        desc: 'Technical lead across Godot and Unreal Engine 5 projects, including an Epic MegaGrant proposal for an educational training simulation.',
        tags: ['Godot', 'Unreal Engine', 'Systems Design'],
    },
    {
        title: 'Freelance Software Engineer',
        company: 'Independent Contractor',
        dates: 'May 2026 — Present',
        desc: 'Designed, built, and deployed production web applications with SEO optimization, analytics integration, and ongoing client maintenance.',
        tags: ['Full-Stack', 'React', 'SEO'],
    },
    {
        title: 'Undergraduate Research Assistant',
        company: 'NSF REU — University of Rochester',
        dates: 'Jan 2023 — May 2025',
        desc: 'Published at IEEE BigData 2023 and co-authored three arXiv papers on electoral control complexity. Served as conference referee at MFCS 2024.',
        tags: ['ML Research', 'COMSOC', 'Python', 'LaTeX'],
    },
];

function ExperienceSnapshot() {
    return (
        <section className="about-section">
            <p className="section-eyebrow">Where I've worked</p>
            <h2 className="section-title">Experience</h2>

            <div className="exp-list">
                {EXPERIENCES.map(e => (
                    <div className="exp-item" key={e.title + e.company}>
                        <div className="exp-meta">
                            <span className="exp-dates">{e.dates}</span>
                        </div>
                        <div className="exp-body">
                            <div className="exp-header">
                                <h3 className="exp-title">{e.title}</h3>
                                <span className="exp-company">{e.company}</span>
                            </div>
                            <p className="exp-desc">{e.desc}</p>
                            <div className="exp-tags">
                                {e.tags.map(t => (
                                    <span className="tech-pill" key={t}>{t}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="section-cta-row">
                <Link to="/experience" className="outline-btn">
                    Full work history →
                </Link>
            </div>
        </section>
    );
}

export default ExperienceSnapshot;